import { useErrorNotificationApi, UserRoles } from '@equifinance/shared';
import {
  Application, ApplicationStageBackward, ChangeStatusOptions, TransitionBackwardResponse,
} from '../contexts/applications';
import { InternalUser } from '../contexts/underwriters';
import { WithdrawalReason, WithdrawReasonType } from './useAccountApi';

const apiPath = `${process.env.REACT_APP_ORIGINATION_API_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

export type ApplicationApiType = {
  getInternalUsers: (permissionType: UserRoles) => Promise<InternalUser[]>,
  getApplications: () => Promise<Application[]>,
  putUpdateUnderwriterOwner: (ownerId: string, underwriterAssignedToId: string, underwriterAssignedToName: string | null) => Promise<Application>,
  putReopenApplication: (applicationId: string) => Promise<Application>,
  getRejectionReasons: () => Promise<WithdrawalReason[]>,
  putRejectApplication: (applicationId: string, rejectReason: WithdrawReasonType) => Promise<Application>,
  putWithdrawApplication: (applicationId: string, withdrawReason: WithdrawReasonType) => Promise<Application>,
  getApplicationChangeStatusOptions: (applicationId: string) => Promise<ChangeStatusOptions>,
  putChangeApplicationStatus: (applicationId: string, stage: ApplicationStageBackward) => Promise<TransitionBackwardResponse>,
}

export default function useApplicationApi(): ApplicationApiType {
  const {
    get, put,
  } = useErrorNotificationApi(apiUrl);

  return {
    getInternalUsers: (permissionType: UserRoles): Promise<InternalUser[]> => get(`users/internal/${permissionType}`),
    getApplications: (): Promise<Application[]> => get('casemanagement/applications'),
    putUpdateUnderwriterOwner: (
      applicationId,
      underwriterAssignedToId,
      underwriterAssignedToName,
    ) => put(`casemanagement/case/${applicationId}/update-underwriter-owner`, {
      underwriterAssignedToId,
      underwriterAssignedToName,
    }),
    putReopenApplication: (applicationId: string) => put(`CaseManagement/case/${applicationId}/underwriter-reopen`, {}),
    getRejectionReasons: () => get('CaseManagement/static/rejection-reasons'),
    putRejectApplication: (applicationId, rejectReason) => put(`CaseManagement/case/${applicationId}/underwriter-reject`, rejectReason),
    putWithdrawApplication: (applicationId, withdrawReason) => put(`CaseManagement/case/${applicationId}/underwriter-withdraw`, withdrawReason),
    getApplicationChangeStatusOptions: (applicationId: string) => get(`transition/${applicationId}/application-change-status-options`),
    putChangeApplicationStatus: (applicationId: string, stage: string) => put(`transition/${applicationId}/change-status/${stage}`, {}),
  };
}
